module.exports = __webpack_public_path__ + "./img-yachu_7c405942a8ed9eceeda28032b49f8854.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2018/img-yachu.png
// module id = 468
// module chunks = 0